// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

// #region Imports

import * as React from 'react';
import BuilderContext from "../../contexts/DataTestIdBuilderContext";
import StringBuilder from "../../utils/StringBuilder";

// #endregion

/**
 * Composant permettant de bloquer l'utilisation des préfixes qui serait
 * plus haut dans l'arbre React
 */
import { jsx as _jsx } from "react/jsx-runtime";
var PrefixBorder = function PrefixBorder(_ref) {
  var children = _ref.children;
  var stringBuilder = React.useMemo(function () {
    return StringBuilder.create();
  }, []);
  return /*#__PURE__*/_jsx(BuilderContext.Provider, {
    value: stringBuilder,
    children: children
  });
};
export default PrefixBorder;